"use client";

import { useEffect, useRef } from "react";

import { DEFAULT_EASE } from "@/lib/animation";
import { gsap, ScrollTrigger } from "@/lib/gsap";

import styles from "./StorySection.module.scss";

gsap.registerPlugin(ScrollTrigger);

export default function StorySection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  const titleRef = useRef<HTMLHeadingElement>(null);

  const textRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    if (
      !sectionRef.current ||
      !titleRef.current ||
      !textRef.current
    ) {
      return;
    }

    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
      });

      gsap.set(titleRef.current, {
        opacity: 0,
        y: 40,
      });

      gsap.set(textRef.current, {
        opacity: 0,
        y: 60,
      });

      tl.to(titleRef.current, {
        opacity: 1,
        y: 0,
        duration: 1.2,
        ease: DEFAULT_EASE,
      });

      tl.to(
        textRef.current,
        {
          opacity: 1,
          y: 0,
          duration: 1.4,
          ease: DEFAULT_EASE,
        },
        "-=0.7"
      );
    }, sectionRef);

    return () => {
      ctx.revert();
    };
  }, []);

  return (
    <section className={styles.story}>
      <div className={styles.inner} ref={sectionRef}>
        <h4
          className={styles.title}
          ref={titleRef}
        >
          Football has the power to move the world as one.
        </h4>

        <p
          className={styles.text}
          ref={textRef}
        >
          Beyond the pitch, it connects generations and
          cultures and moments. Within this journey shaped
          by FIFA, Kia moves forward as a long-term
          partner— nurturing both the present and future of
          the game, guided by our brand slogan, “Movement
          that inspires.”
        </p>
      </div>
    </section>
  );
}